import { render, staticRenderFns } from "./EditClientForm.vue?vue&type=template&id=8f607ae0&"
import script from "./EditClientForm.vue?vue&type=script&lang=js&"
export * from "./EditClientForm.vue?vue&type=script&lang=js&"
import style0 from "./EditClientForm.vue?vue&type=style&index=0&id=8f607ae0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports